module.exports = {
    install(Vue) {
        Vue.prototype.$ongwLib = new Vue({
            data: {
                monthList:[
                    {addYear:0,value:"03",text:"3월"},
                    {addYear:0,value:"04",text:"4월"},
                    {addYear:0,value:"05",text:"5월"},
                    {addYear:0,value:"06",text:"6월"},
                    {addYear:0,value:"07",text:"7월"},
                    {addYear:0,value:"08",text:"8월"},
                    {addYear:0,value:"09",text:"9월"},
                    {addYear:0,value:"10",text:"10월"},
                    {addYear:0,value:"11",text:"11월"},
                    {addYear:0,value:"12",text:"12월"},
                    {addYear:1,value:"01",text:"1월"},
                    {addYear:1,value:"02",text:"2월"},
                ],
            },
            methods:{
                getWethrClass : function(wethrCd) {
                    if (typeof wethrCd !='undefined' || wethrCd != null || wethrCd != '') {
                        var val;

                        if (wethrCd == '010' || wethrCd == '맑음') {				/*맑음*/
                            val = "img-com __icon-wt01";
                        } else if (wethrCd == '020' || wethrCd == '구름 조금') {			/*구름조금*/
                            val = "img-com __icon-wt02";
                        } else if (wethrCd == '030' || wethrCd == '구름 많음') {			/*구름많음*/
                            val = "img-com __icon-wt04";
                        } else if (wethrCd == '040' || wethrCd == '흐림') {			/*흐림*/
                            val = "img-com __icon-wt03";
                        } else if (wethrCd == '080' || wethrCd == '소나기') {			/*소나기*/
                            val = "img-com __icon-wt05";
                        } else if (wethrCd == '050' || wethrCd == '비') {			/*비*/
                            val = "img-com __icon-wt08";
                        } else if (wethrCd == '060' || wethrCd == '눈/비') {			/*눈/비*/
                            val = "img-com __icon-wt06";
                        } else if (wethrCd == '070' || wethrCd == '눈') {			/*/눈*/
                            val = "img-com __icon-wt07";
                        }

                        return val;
                    }
                },
                getFineDustClass : function(gnb, fineDustCd){
                    var val = "";
                    if(gnb == 'txt'){
                        if(fineDustCd == '좋음' || fineDustCd == '100'){
                            val = "pc02";
                        }else if(fineDustCd == '보통'||fineDustCd == '200'){
                            val = "pc03";
                        }else if(fineDustCd == '나쁨'||fineDustCd == '300'){
                            val = "pc04";
                        }
                    }else{
                        if(fineDustCd == '좋음' || fineDustCd == '100'){
                            val = "img-com __icon-wt-dust-gd";
                        }else if(fineDustCd == '보통'|| fineDustCd == '200'){
                            val = "img-com __icon-wt-dust-nd";
                        }else if(fineDustCd == '나쁨'|| fineDustCd == '300'){
                            val = "img-com __icon-wt-dust-bd";
                        }else if(fineDustCd == '아주나쁨'|| fineDustCd == '400'){
                            val = "img-com __icon-wt-dust-bbd";
                        }
                    }
                    return val;
                },
                getApprSttusNm : function(codeList, apprSttus){
                    for(var i=0;i<codeList.length;i++){
                        if(codeList[i]['cd']==apprSttus){
                            return codeList[i]['cdNm'];
                        }
                    }
                    if(apprSttus=="NEW"){
                        return "신규작성";
                    }
                },
                getDateStr:function(str, format){
                    if(!str) return;
                    str = str.toString();
                    str = str.replace(/[-.]/g,"");
                    if(str.length<4) return str;

                    var year = str.substr(0,4);
                    var month = str.length>=6?str.substr(4,2):"";
                    var day = str.length>=8?str.substr(6,2):"";

                    if(!format){
                        if(str.length==8) format = "YYYY.MM.DD";
                        else if(str.length==6) format = "YYYY.MM";
                        else if(str.length==4) format = "YYYY";
                    }
                    format = format.toUpperCase();
                    format = format.replace("YYYY", year);
                    format = format.replace("MM", month);
                    format = format.replace("DD", day);

                    format = format.replace("YY", year.substr(2,2));
                    format = format.replace("M", parseInt(month,10).toString());
                    format = format.replace("D", parseInt(day).toString());
                    return format;
                },
                addDays:function(date, days){
                    date.setDate(date.getDate() + days);
                    return date;
                },
                getYmdFromDate:function(date){
                    var yyyy = date.getFullYear();
                    var mm = date.getMonth() + 1;
                    var dd = date.getDate();

                    return [yyyy, (mm>9?'':'0')+mm, (dd>9?'':'0')+dd].join('');
                },
                getDateFromToStr:function(str1, str2, format){
                    if(!str1) return;
                    str1 = str1.toString();
                    str1 = str1.replace(/[-.]/g,"");
                    if(str1.length<4) return str1;

                    str2 = str2.toString();
                    str2 = str2.replace(/[-.]/g,"");

                    var year1 = str1.substr(0,4);
                    var month1 = str1.length>=6?str1.substr(4,2):"";
                    var day1 = str1.length>=8?str1.substr(6,2):"";

                    var year2 = str2.substr(0,4);
                    var month2 = str2.length>=6?str2.substr(4,2):"";
                    var day2 = str2.length>=8?str2.substr(6,2):"";

                    if(!format){
                        format = "F_YYYY.F_MM.F_DD ~ T_YYYY.T_MM.T_DD";
                    }
                    format = format.toUpperCase();
                    format = format.replace("F_YYYY", year1);
                    format = format.replace("F_MM", month1);
                    format = format.replace("F_DD", day1);

                    format = format.replace("F_YY", year1.substr(2,2));
                    format = format.replace("F_M", parseInt(month1,10).toString());
                    format = format.replace("F_D", parseInt(day1).toString());

                    format = format.replace("T_YYYY", year2);
                    format = format.replace("T_MM", month2);
                    format = format.replace("T_DD", day2);

                    format = format.replace("T_YY", year2.substr(2,2));
                    format = format.replace("T_M", parseInt(month2,10).toString());
                    format = format.replace("T_D", parseInt(day2).toString());

                    return format;
                },
                searchClasList: function(fcltcd){
                    const ongwLib = this;
                    let clasList = new Array();
                    let groupClasList = new Array();

                    return new Promise(function (resolve, reject) {
                        ongwLib.searchNorClasList(fcltcd).then(function(setClasList){
                            clasList = setClasList;
                            return ongwLib.searchGrpClasList(fcltcd);
                        }).then(function(setGroupClasList){
                            groupClasList = setGroupClasList;
                            return ongwLib.searchTotClasList(clasList,groupClasList);
                        }).then(function(setTotClasList){
                            resolve({
                                clasList:clasList,
                                groupClasList:groupClasList,
                                totClasList:setTotClasList
                            });
                        }).catch(function(e){
                            reject(e);
                        });
                    });
                },
                searchNorClasList: function(fcltcd){
                    const ongwLib = this;
                    return new Promise(function (resolve, reject) {
                        ongwLib.axios.post('/works/common/searchClasList.act',{
                            fcltcd: fcltcd
                        }).then(function(response) {
                            resolve(response.data.clasList);
                        }.bind(this)).catch(function(e) {
                            reject(e);
                        });
                    });
                },
                searchGrpClasList: function(fcltcd){
                    const ongwLib = this;
                    return new Promise(function (resolve, reject) {
                        ongwLib.axios.post('/works/common/searchGroupClasList.act',{
                            fcltcd: fcltcd
                        }).then(function(response) {
                            resolve(response.data.groupClasList);
                        }.bind(this)).catch(function(e) {
                            reject(e);
                        });
                    });
                },
                searchTotClasList: function(clasList,groupClasList){
                    return new Promise(function (resolve) {
                        let totClasList = new Array();

                        groupClasList.forEach(function(groupClasInfo){
                            groupClasInfo['clasOrgAt'] = 'Y';
                            groupClasInfo['showClasNm'] = groupClasInfo.clasNmOrg;
                            totClasList.push(groupClasInfo);

                            if(groupClasInfo.clasSnOrgCnt > 1){
                                let setClasList = clasList.filter(function(clasInfo){
                                    return clasInfo.clasSnOrg == groupClasInfo.clasSn;
                                });

                                setClasList.forEach(function(setClasInfo){
                                    setClasInfo['clasOrgAt'] = "N";
                                    setClasInfo['showClasNm'] = " ㆍ " + setClasInfo.clasNm;
                                    totClasList.push(setClasInfo);
                                });

                                groupClasInfo.clasSn = groupClasInfo.clasSns;
                            }
                        });

                        resolve(totClasList);
                    });
                },
                searchClasChilList: function(searchInfo){
                    const ongwLib = this;
                    return new Promise(function (resolve, reject) {
                        ongwLib.axios.post('/works/chilClas/chil/searchChilStatusList.act',searchInfo)
                            .then(function(response) {
                                resolve(response.data.chilStatusList);
                            }.bind(this)).catch(function(e) {
                            reject(e);
                        });

                    });

                },
                searchYearMonthList:function(year){
                    var curYear = year.toString();
                    var nextYear = (parseInt(year,10)+1).toString();
                    var yearMonthList = new Array();
                    yearMonthList[yearMonthList.length] = {value:curYear+"03",text:curYear+".03"};
                    yearMonthList[yearMonthList.length] = {value:curYear+"04",text:curYear+".04"};
                    yearMonthList[yearMonthList.length] = {value:curYear+"05",text:curYear+".05"};
                    yearMonthList[yearMonthList.length] = {value:curYear+"06",text:curYear+".06"};
                    yearMonthList[yearMonthList.length] = {value:curYear+"07",text:curYear+".07"};
                    yearMonthList[yearMonthList.length] = {value:curYear+"08",text:curYear+".08"};
                    yearMonthList[yearMonthList.length] = {value:curYear+"09",text:curYear+".09"};
                    yearMonthList[yearMonthList.length] = {value:curYear+"10",text:curYear+".10"};
                    yearMonthList[yearMonthList.length] = {value:curYear+"11",text:curYear+".11"};
                    yearMonthList[yearMonthList.length] = {value:curYear+"12",text:curYear+".12"};
                    yearMonthList[yearMonthList.length] = {value:nextYear+"01",text:nextYear+".01"};
                    yearMonthList[yearMonthList.length] = {value:nextYear+"02",text:nextYear+".02"};
                    return yearMonthList;
                },
                searchWorkGrpDefList: function(){
                    const ongwLib = this;
                    return new Promise(function (resolve, reject) {
                        ongwLib.axios.post('/works/common/searchWorkGrpDefList.act')
                            .then(function(response) {
                                resolve(response.data.workGrpDefList);
                            }.bind(this)).catch(function(e) {
                                reject(e);
                            });
                    });
                },
                searchNrtrYearList:function(curYear){
                    //2014년도부터 현재년도
                    let nrtrYearList = new Array();
                    let nrtrYear;

                    for(nrtrYear = Number(curYear); nrtrYear >= 2014; nrtrYear--){
                        nrtrYearList.push({nrtrYear : nrtrYear});
                    }

                    return nrtrYearList;
                },
                searchEmpClasSn: function(clasList,nrtrYear,clasSe,empClasList){
                    let empClasSn = '';

                    let searchAt1 = false;
                    let searchAt2 = false;

                    if(typeof clasList != 'undefined' && clasList != null){
                        if(clasList.length > 0) searchAt1 = true;
                    }

                    if(typeof empClasList != 'undefined' && empClasList != null){
                        if(empClasList.length > 0) searchAt2 = true;
                    }


                    if(searchAt1) empClasSn = clasList[0].clasSn;

                    if(searchAt1&&searchAt2){
                        const empClasInfo = empClasList.find(function(info){
                            return nrtrYear == info.year;
                        });

                        if(empClasInfo != null){
                            const clasInfo = clasList.find(function(info){
                                let compClasSn = empClasInfo['clasSn'];
                                if(clasSe == 'org') compClasSn = empClasInfo['clasSnOrg'];
                                return info.clasSn.indexOf(compClasSn) > -1;
                            });

                            if(clasInfo == null){
                                empClasSn = clasList[0].clasSn;
                            }else{
                                empClasSn = clasInfo.clasSn;
                            }
                        }else{
                            empClasSn = clasList[0].clasSn;
                        }
                    }else if(searchAt1&&!searchAt2){
                        empClasSn = clasList[0].clasSn;
                    }

                    return empClasSn;
                },
                searchFcltCodeList:function(searchInfo){
                    const ongwLib = this;
                    return new Promise(function (resolve, reject) {
                        ongwLib.axios.post('/works/common/searchFcltCodeList.act', {
                            searchInfo : searchInfo
                        }).then(function(response) {
                            resolve(response.data.codeList);
                        }.bind(this)).catch(function(e) {
                            reject(e);
                        });
                    });
                },
                searchMonthList:function(){
                    let monthList = new Array();

                    for(let i=0;i<this.monthList.length;i++){
                        monthList.push(this.monthList[i]);
                    }

                    return monthList;
                },
            },

        });

    }
};